<div class="LocationSearch">

    <span class="InputGroup">
        <Superinput :clearButton="true" placeholder="Ort oder Adresse" @enter="onSearchButtonClick" v-model="pQuery" />
        <Superbutton title="Suchen" icon="tivigi/img/search.svg" @click="onSearchButtonClick" />
    </span>

    <FloatingWindow :show.sync="showResults" v-if="result != null" :dockButton="false" :title="'Ortssuche: ' + result.length + ' Ergebnisse für &quot;' + lastQuery + '&quot;'">
        <div class="LocationSearch__Result">

            <div class="LocationSearch__NoResult" v-if="result.length == 0">
                Keine Orte gefunden
            </div>

            <template v-else>
                <button class="Button" v-for="entry in result" @click="onEntryClick(entry)">
                    {{entry.display_name}}
                </button>
            </template>
        </div>
    </FloatingWindow>
</div>
